module.exports = __webpack_public_path__ + "img/Photo_1__Ship_Building_976_280_5.b807fd7e.jpg";